import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login/login.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ResetPasswordComponent } from './reset-password/reset-password.component';
// import { CoreModule } from 'src/app/core/core.module';
import { ReactiveFormsModule } from '@angular/forms';
import { PasswordUpdatedComponent } from './password-updated/password-updated.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TooltipPipe } from 'src/app/core/_pipes/tooltip.pipe';


@NgModule({
  declarations: [
    LoginComponent,
    ForgotPasswordComponent,
    ResetPasswordComponent,
    PasswordUpdatedComponent,
    VerifyEmailComponent,
    TooltipPipe
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,
    MatTooltipModule,
    ReactiveFormsModule,
    MatIconModule,
  ]
})
export class AuthModule { }
